import {Component, ChangeDetectionStrategy, OnInit, ViewChild, TemplateRef, AfterViewInit, OnDestroy, ChangeDetectorRef, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ButtonModule} from 'primeng/button';
import {InputTextModule} from 'primeng/inputtext';
import {TableModule} from 'primeng/table';
import {TagModule} from 'primeng/tag';
import {PaginatorModule} from 'primeng/paginator';
import {FormsModule} from '@angular/forms';
import {CheckboxModule} from 'primeng/checkbox';
import {CardModule} from 'primeng/card';
import {DatePickerModule} from 'primeng/datepicker';
import {SelectModule} from 'primeng/select';
import {MenuModule} from 'primeng/menu';
import {MenuItem} from 'primeng/api';
import {
  ListTableFiltersWrapperParent
} from '@app/wrappers/pages/list-table-filters-wrapper/list-table-filters-wrapper-parent';
import {UserTicket, UserTicketService, SystemInfoService, LocalizedModuleInfo} from '@6grain/masofa-monolith-api-client/common';
import { APPEAL_STATUS_OPTIONS } from '@shared/data/appeals-statuses-data';
import { getAppealStatusLabel, getAppealStatusSeverity } from '@shared/data/appeals-status-utils';
import {IMsfFormBuilder} from "@root/src/app/components/form-builder/form-builder";
import {ListTableFiltersWrapper} from '@app/wrappers/pages/list-table-filters-wrapper/list-table-filters-wrapper';
import {RequestParams} from '@components/select/resource-component';
import { Router } from '@angular/router';
import {DateFormatLangPipe} from '@app/utils/pipes/date-format-lang-pipe';
import {TableColumn} from '@components/data-table/data-table.component';
import { DatePipe } from '@angular/common';
import {UserDeviceService, UserService} from '@6grain/masofa-monolith-api-client/identity';
import { SortType } from '@6grain/masofa-monolith-api-client/crop-monitoring/model/sortType';
import { ConfirmationModalComponent } from '@app/components/confirmation-modal/confirmation-modal.component';
import { UserTicketService as CommonUserTicketService } from '@6grain/masofa-monolith-api-client/common';


@Component({
  selector: 'app-appeals-page',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule,
    InputTextModule,
    TableModule,
    TagModule,
    PaginatorModule,
    FormsModule,

    CheckboxModule,
    CardModule,
    DatePickerModule,
    SelectModule,
    MenuModule,
    ListTableFiltersWrapper,
    DateFormatLangPipe,
    ConfirmationModalComponent,

  ],
  providers: [DatePipe, DateFormatLangPipe],
  templateUrl: './appeals-page.html',
  styleUrl: './appeals-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppealsPageComponent extends ListTableFiltersWrapperParent<UserTicket, UserTicketService> implements OnInit, AfterViewInit, OnDestroy {
  override filtersForms: IMsfFormBuilder[] = [];
  override getAllMethod = 'commonUserTicketGetByQueryPost'
  override getTotalMethod = 'commonUserTicketGetTotalCountPost'
  override storageKey = 'admin_appeals_list_table'

  @ViewChild('createAt', {static: true}) createAt!: TemplateRef<any>;
  @ViewChild('moduleNameTemplate', {static: true}) moduleNameTemplate!: TemplateRef<any>;
  @ViewChild('statusTemplate', {static: true}) statusTemplate!: TemplateRef<any>;
  @ViewChild('actionsTemplate', {static: true}) actionsTemplate!: TemplateRef<any>;

  // Store menu references for each row
  actionMenus: Map<string, any> = new Map();

  // Confirmation modals
  showCloseTicketModal = false;
  showRejectTicketModal = false;
  pendingTicketAction: { row: any; action: 'close' | 'reject' } | null = null;
  currentMenuRow: any = null;


   defaultParams: RequestParams = {
    take: 10,
    offset: 0,
    sortBy: 'CreateAt',
    sort: SortType.NUMBER_1,
    filters: []
  }

  tableColumns: TableColumn[] = [];


  public service = inject(UserTicketService);
  public userService = inject(UserService);
  public userDeviceService = inject(UserDeviceService);
  public tr = inject(TranslateService);
  private router = inject(Router);
  private systemInfoService = inject(SystemInfoService);
  private cdr = inject(ChangeDetectorRef);
  private userTicketService = inject(CommonUserTicketService);

  // Module localization
  private localizedModules: LocalizedModuleInfo[] = [];
  private langChangeSubscription: any;

  constructor() {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();

    // Load module options from backend
    this.loadModuleOptions();

    // Subscribe to language changes to update module translations
    this.langChangeSubscription = this.tr.onLangChange.subscribe(() => {
      this.updateModuleTranslations();
      // Force change detection to update table with new translations
      this.cdr.markForCheck();
    });

    this.filtersForms = [
      {
        type: 'select',
        title: this.tr.instant('Status'),
        placeholder: this.tr.instant('Status'),
        name: 'status',
        selectOptions: APPEAL_STATUS_OPTIONS,
        options: {
          select: {
            optionLabel: 'label',
            optionValue: 'value',
            translateBy: 'names'
          }
        }
      },
      {
        type: 'select',
        title: this.tr.instant('User'),
        placeholder: this.tr.instant('User'),
        name: 'createUserName',
        selectService: this.userService,
        selectServiceMethod: 'identityUserGetByQueryPost',
        options:{
          select:{
            optionLabel: 'userName',
            translateBy:'none'
          }
        }
      },
      {
        type: 'select',
        title: this.tr.instant('Device Type'),
        placeholder: this.tr.instant('Device Type'),
        name: 'deviceTypeId',
        selectService: this.userDeviceService,
        selectServiceMethod: 'identityUserDeviceGetByQueryPost',
        options:{
          select:{
            optionLabel: 'deviceName',
            translateBy:'none'
          }
        }
      }
    ]
  }

  ngAfterViewInit() {
    this.tableColumns = [
        { field: '', header: this.tr.instant('Date / Time'), type: 'custom', customTemplate: this.createAt },
        { field: 'createUserName', header: this.tr.instant('User') },
        { field: '', header: this.tr.instant('Module Name'), type: 'custom', customTemplate: this.moduleNameTemplate },
        { field: '', header: this.tr.instant('Status'), type: 'custom', customTemplate: this.statusTemplate },
        { field: 'exceptionType', header: this.tr.instant('Exceptions Types') },
        { field: 'userDeviceType', header: this.tr.instant('User Device Types') },
        { field: 'number', header: this.tr.instant('Number') },
        { field: '', header: '', type: 'custom', customTemplate: this.actionsTemplate }
      ];
  }

  goToChat(row: any) {
    this.router.navigate([`/admin/appeals/chat/${row.id}`]);
  }

  getActionMenuItems(row: any): MenuItem[] {
    // Store the current row for menu actions
    const currentRow = row;
    return [
      {
        label: this.tr.instant('Close Ticket'),
        icon: 'pi pi-check',
        command: () => {
          this.closeTicket(currentRow);
        }
      },
      {
        label: this.tr.instant('Reject Ticket'),
        icon: 'pi pi-times',
        command: () => {
          this.rejectTicket(currentRow);
        }
      }
    ];
  }

  closeTicket(row: any): void {
    this.pendingTicketAction = { row, action: 'close' };
    this.showCloseTicketModal = true;
    this.cdr.markForCheck();
  }

  rejectTicket(row: any): void {
    this.pendingTicketAction = { row, action: 'reject' };
    this.showRejectTicketModal = true;
    this.cdr.markForCheck();
  }

  onConfirmStatusChange(): void {
    if (!this.pendingTicketAction) return;

    const { row, action } = this.pendingTicketAction;
    const newStatus = action === 'close' ? 3 : 2; // 3 = Complete, 2 = Rejected

    const updatedTicket: UserTicket = {
      ...row,
      ticketStatus: newStatus
    };

    this.userTicketService.commonUserTicketUpdatePut(updatedTicket).subscribe({
      next: (updated) => {
        // Update the ticket in the list
        const index = this.data.findIndex((t: UserTicket) => t.id === updated.id);
        if (index !== -1) {
          this.data[index] = updated;
        }
        this.pendingTicketAction = null;
        this.showCloseTicketModal = false;
        this.showRejectTicketModal = false;
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.error('Failed to update ticket status:', error);
        this.tr.instant('Failed to update ticket status');
        this.pendingTicketAction = null;
        this.showCloseTicketModal = false;
        this.showRejectTicketModal = false;
        this.cdr.markForCheck();
      }
    });
  }

  onCancelStatusChange(): void {
    this.pendingTicketAction = null;
    this.showCloseTicketModal = false;
    this.showRejectTicketModal = false;
    this.cdr.markForCheck();
  }

  toggleActionMenu(event: Event, menu: any, row: any): void {
    this.currentMenuRow = row;
    menu.toggle(event);
    event.stopPropagation();
  }

  getStatusLabel(status: number): string {
    return getAppealStatusLabel(status, this.tr);
  }

  getStatusSeverity(status: number): string {
    return getAppealStatusSeverity(status);
  }

  // Load module options from backend with localization
  private loadModuleOptions(): void {
    this.systemInfoService.commonSystemInfoGetAvailableModulesLocalizedGet().subscribe({
      next: (modules: LocalizedModuleInfo[]) => {
        this.localizedModules = modules;
        this.updateModuleTranslations();
      },
      error: (error: any) => {
        console.error('Error loading modules:', error);
        // Fallback to empty array - modules will show original names
        this.localizedModules = [];
      }
    });
  }

  // Update module option labels with current language translations
  private updateModuleTranslations(): void {
    // This is called when language changes, but we don't need to update options here
    // as we're only using modules for table display, not dropdown
  }

  // Get localized module name by module name string (for table display)
  getLocalizedModuleNameByName(moduleName: string | null | undefined): string {
    if (!moduleName) {
      return 'Unknown';
    }

    const module = this.localizedModules.find(m => m.moduleName === moduleName);
    if (!module) {
      return moduleName; // Fallback to original name if not found
    }

    const currentLang = this.getCurrentLanguageKey();
    return this.getLocalizedModuleName(module, currentLang);
  }

  // Get localized module name for current language
  private getLocalizedModuleName(module: LocalizedModuleInfo, languageKey: string): string {
    if (!module.localizedNames || !module.moduleName) {
      return module.moduleName || 'Unknown';
    }

    // First, try to get value from direct properties (e.g., localizedNames['ru-RU'])
    let names: any = module.localizedNames;

    // Check if direct property exists for current language
    const directValue = names[languageKey];
    if (directValue && typeof directValue === 'string' && directValue.trim()) {
      return directValue;
    }

    // If not found and valuesJson exists, try parsing it
    if (module.localizedNames.valuesJson && typeof module.localizedNames.valuesJson === 'string') {
      try {
        const parsed = JSON.parse(module.localizedNames.valuesJson);
        if (parsed && typeof parsed === 'object') {
          names = parsed;
          const parsedValue = names[languageKey];
          if (parsedValue && typeof parsedValue === 'string' && parsedValue.trim()) {
            return parsedValue;
          }
        }
      } catch (e) {
        console.warn('Failed to parse valuesJson:', e);
      }
    }

    // Fallback to other languages in order of preference
    const fallbackLanguages = ['ru-RU', 'en-US', 'uz-Latn-UZ', 'uz-Cyrl-UZ', 'ar-LB'];
    for (const lang of fallbackLanguages) {
      const value = names[lang];
      if (value && typeof value === 'string' && value.trim()) {
        return value;
      }
    }

    // Final fallback to module name
    return module.moduleName;
  }

  // Get current language key in format expected by API (ru-RU, en-US, etc.)
  private getCurrentLanguageKey(): string {
    // TranslateService already uses full format: 'ru-RU', 'en-US', 'uz-Latn-UZ', 'ar-LB'
    const currentLang = this.tr.currentLang || this.tr.defaultLang || 'en-US';

    // If currentLang is already in API format, return it directly
    // Map 'ar-LB' to 'ar-LB' for API compatibility
    if (currentLang === 'ar-LB') {
      return 'ar-LB';
    }

    // Return as-is if it's already in the correct format
    return currentLang;
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }
}
